/** Every web app serves its login page here; core-api's invite and reset links point at it too. */
export const LOGIN_PATH = '/auth/login';
/** Pages under it are for signed-out users, so they are never a post-login destination. */
export const AUTH_PATH_PREFIX = '/auth/';
